import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { translate, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';

import { GetIntegrationStatus, RetryIntegrationStatus } from '../../store/actions';
import { getCurrentOrganizationId$, getIntegrationStatus$, getSessionUserId$ } from '../../store/selectors';

@Component({
    selector: 'app-integration-status-dialog',
    templateUrl: './integration-status-dialog.component.html',
    styleUrls: ['./integration-status-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class IntegrationStatusDialogComponent implements OnDestroy, OnInit {
    @Input() public record: any;

    private unSubscribe = new Subject<void>();
    public integrationStatus = 'Not Applicable';
    public statusColor = '';
    private currentOrganizationId: string;
    private userId: string;

    constructor(private store$: Store, private dialogRef: MatDialogRef<IntegrationStatusDialogComponent>) {}

    private getIntegrationStatus = () => {
        this.store$.dispatch(GetIntegrationStatus({ instanceId: this.record?.recordId }));
    };

    public changeTextColor = (status: string) => {
        if (status === 'Not Applicable' || status === 'Failed') {
            return '!text-red-500';
        } else if (status === 'Completed' || status === 'In-Progress') {
            return '!text-green-500';
        }
        return '';
    };

    fetchIntegrationRetryStatus = () => {
        this.store$.dispatch(
            RetryIntegrationStatus({
                requestId: this.record?.requestId,
                unitId: this.currentOrganizationId,
                assetId: this.record?.assetId,
                bridgeId: this.record?.bridgeId,
                serviceId: this.record?.serviceId,
                assetDataId: this.record?.recordId,
                userId: this.userId,
                requestLevel: false,
                noAlerts: this.record?.noAlerts,
            })
        );
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    ngOnInit(): void {
        this.store$
            .select(getCurrentOrganizationId$)
            .pipe(takeUntil(this.unSubscribe))
            .subscribe(organizationId => {
                this.currentOrganizationId = organizationId;
            });
        this.store$
            .select(getSessionUserId$)
            .pipe(takeUntil(this.unSubscribe))
            .subscribe(userId => {
                this.userId = userId;
            });
        this.store$
            .select(getIntegrationStatus$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(integrationStatuses => {
                const status = integrationStatuses[this.record?.recordId] || 'NOT_APPLICABLE';
                switch (status) {
                    case 'NOT_INITIATED':
                        this.integrationStatus = translate('Not Initiated');
                        this.statusColor = '';
                        break;
                    case 'NOT_APPLICABLE':
                        this.integrationStatus = translate('Not Applicable');
                        this.statusColor = '!text-red-500';
                        break;
                    case 'FAILED':
                        this.integrationStatus = translate('Failed');
                        this.statusColor = 'red';
                        break;
                    case 'COMPLETED':
                        this.integrationStatus = translate('Completed');
                        this.statusColor = '!text-green-500';
                        break;
                    case 'INPROGRESS':
                        this.integrationStatus = translate('In-Progress');
                        this.statusColor = 'green';
                        break;
                    default:
                        this.integrationStatus = status;
                        this.statusColor = '';
                        break;
                }
            });

        this.getIntegrationStatus();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
